import { Button, ButtonProps } from '@heroui/react'
import { CenteredLayout } from '#widgets/layouts/centered-layout'
import styles from './page-empty-state.module.scss'

interface PageEmptyState {
  children?: React.ReactNode
  buttonLabel?: string
  buttonProps?: ButtonProps
}

export default function PageEmptyState({ children, buttonLabel, buttonProps }: PageEmptyState) {
  return (
    <CenteredLayout>
      <div className={styles.root}>
        <div className={styles.text}>{children}</div>
        {buttonLabel && (
          <Button size="lg" color="primary" {...buttonProps}>
            {buttonLabel}
          </Button>
        )}
      </div>
    </CenteredLayout>
  )
}
